import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { useTranslation } from 'react-i18next';

import { useChargePointChannelContext } from '../../charge-point.context';

export const ChargePointChannelTransactionStopFormStep1Controller =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    const { t } = useTranslation();
    const channel = useChargePointChannelContext();

    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <>
        <Text bold>
          {t('$.charge-point-channel-transaction-stop.step-1.confirm', {
            channelId: channel.id,
          })}
        </Text>
        <Text italic>
          {t('$.charge-point-channel-transaction-stop.step-1.warning')}
        </Text>
      </>
    );
  };
